import { SET_FONT_IS_LOADED } from '../actionTypes'

export const setFontIsLoaded = (fontFamily: string) => ({
  type: SET_FONT_IS_LOADED,
  payload: { fontFamily },
})
